import { Component } from '@angular/core';
import {
  PlayerProfileOverviewHeaderComponent
} from './player-profile-overview-header/player-profile-overview-header.component';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-player-profile-overview',
  imports: [
    PlayerProfileOverviewHeaderComponent,
    RouterOutlet
  ],
  templateUrl: './player-profile-overview.component.html',
  styleUrl: './player-profile-overview.component.scss'
})
export class PlayerProfileOverviewComponent
{

}
